//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters } from 'vuex';
import List from '@/components/table';
import createSandboxTemplate from './SandboxTemplateCreate.vue';
import detailSandbox from './SandboxTemplateDetail.vue';
import messageBox from '@/components/messageBox';
import _ from 'lodash';
import { timestampToISO, isoToTimestamp, formattedDate } from '../utils/index';
// isoToTimestamp
// formattedDate
export default {
  components: {
    List,
    createSandboxTemplate,
    detailSandbox,
    messageBox,
  },
  data() {
    return {
      // 加载状态
      loading: false,
      sandboxTypes: [
        { label: 'full', value: 'full' },
        { label: 'partial', value: 'partial' },
      ],
      // 搜索表单
      sandBoxSearch: {
        id: '',
        name: '',
        create_by: '',
        update_by: '',
        create_time: '',
        update_time: '',
      },
      layout: [
        { name: 'name', label: '模版名称' },
        // { name: 'desensitize_rule', label: '模版类型' },
        { name: 'id', label: 'id' },
        { name: 'update_by', label: '更新人' },
        { name: 'update_time', label: '更新时间' },
      ],
      // 新建窗口展示
      createVisible: false,
      // 模型文件部署
      deployVisible: false,
      detailVisible: false,
      operateType: '',
      rowMessage: {},
    };
  },
  computed: {
    ...mapGetters('user', ['getElementList']),
    jurisdiction() {
      const jurisdictionArray = [
        'updateManage_sandboxTemplate_create',
        'updateManage_sandboxTemplate_delete',
        'updateManage_sandboxTemplate_edit',
      ];
      const jurisdictionObj = {};
      for (const item of jurisdictionArray) {
        jurisdictionObj[item] = this.getElementList.includes(item);
      }
      // jurisdictionObj
      // console.log('%c Line:167 🍷 templatejurisdictionObj', 'color:#33a5ff', jurisdictionObj);
      return jurisdictionObj;
    },
  },
  watch: {},
  created() {
    this.loading = true;
  },
  methods: {
    refresh() {
      this.$refs.list.resetPage();
      this.$refs.list.getList();
    },
    // 查看详情
    // toDetail
    toDetail(row) {
      this.rowMessage = row;
      this.detailVisible = true;
    },
    // 获取列表数据
    getList({ pageIndex, pageSize }) {
      // this.sandBoxSearch;
      console.log(
        '%c Line:224 🍰 this.sandBoxSearch',
        'color:#2eafb0',
        this.sandBoxSearch,
        pageSize,
      );
      // this.sandBoxSearch.update_time
      console.log(
        '%c Line:175 🥖 this.sandBoxSearch.update_time',
        'color:#b03734',
        this.sandBoxSearch.update_time,
      );
      const params = {};
      if (this.sandBoxSearch.name) {
        params.name = this.sandBoxSearch.name;
      }
      if (this.sandBoxSearch.id) {
        params.id = this.sandBoxSearch.id;
      }
      if (this.sandBoxSearch.update_by) {
        params.update_by = this.sandBoxSearch.update_by;
      }
      if (this.sandBoxSearch.update_time) {
        // params.update_time = timestampToISO(this.sandBoxSearch.update_time);
        params.update_time_begin = timestampToISO(this.sandBoxSearch.update_time[0]);
        params.update_time_end = timestampToISO(this.sandBoxSearch.update_time[1]);
      }
      return this.$request({
        url: this.$api.getAllSandboxTemplate,
        data: {
          offset: (pageIndex - 1) * pageSize,
          limit: pageSize,
          ...params,
        },
      }).then((res) => {
        // res
        console.log('%c Line:187 🥐 res', 'color:#ea7e5c', res);

        const computedList = res.list.map((item) => {
          return {
            ...item,
            update_time: formattedDate(isoToTimestamp(item.update_time)),
          };
        });
        return {
          list: computedList || [],
          total: Number(res.total_count) || 0,
        };
      });
    },
    // 表单查询
    handleChange: _.debounce(function () {
      this.refresh();
    }, 1000),
    handleReset() {
      this.sandBoxSearch = {
        id: '',
        name: '',
        create_by: '',
        update_by: '',
        create_time: '',
        update_time: '',
      };
      this.refresh();
    },
    // 增删改
    add() {
      this.operateType = 'add';
      this.createVisible = true;
    },
    edit(row) {
      this.rowMessage = row;
      this.operateType = 'edit';
      this.createVisible = true;
    },
    editFromDetail(row) {
      this.rowMessage = row;
      this.operateType = 'edit';
      this.createVisible = true;
    },
    refreshSandbox(row) {
      this.$request({
        url: this.$api.refreshSandbox,
        data: {
          tenant_id: row.id,
        },
      }).then(() => {
        this.$message({
          message:
            row.sandbox_type === 'development'
              ? '预计在1-5分钟后开始执行刷新任务'
              : '将在明天的上午0-6点执行刷新任务',
          type: 'success',
        });
      });
    },
    toDelete({ id, name }) {
      // id
      console.log('%c Line:187 🍻 id', 'color:#33a5ff', id);
      this.$refs.messageBox.show({
        title: '提示',
        content: `确认删除模板“${name}”吗？`,
        titleIconType: 'warning',
        exitButton: true,
        needCancel: true,
        cancelAction: this.$refs.messageBox.close,
        confirmAction: () => {
          this.$request({
            url: this.$api.deleteSandboxTemplate,
            data: { id },
            cb: () => {
              this.$refs.messageBox.close();
              this.refresh();
            },
          });
        },
      });
    },
  },
};
